import React from 'react';

/**
 * Renders a single page-boundary drag handle overlay.
 *
 * Intentionally NOT wrapped in React.memo — the boundary objects are mutated
 * in place by mouseMoveReducer during drag, so the same object reference
 * has a new `.pos` value.  Shallow memo comparison can't detect that change
 * and would suppress the visual update.  These components are lightweight
 * (a few divs each) so re-rendering them is cheap.
 *
 * @param {object}   boundary              - page-break descriptor { ref, pageBreakId, pos, id }
 * @param {object}   margins               - { left } in pt
 * @param {object}   size                  - { width } in pt
 * @param {function} onBoundaryMouseDown   - (e, boundary) => void
 * @param {function} onBoundaryContextMenu - (e, boundary) => void  (right-click to remove)
 */
function PageBoundary({ boundary, margins, size, onBoundaryMouseDown, onBoundaryContextMenu }) {
	const handleMouseDown = (e) => onBoundaryMouseDown(e, boundary);
	const handleContextMenu = (e) => onBoundaryContextMenu(e, boundary);

	return (
		<div
			ref={boundary.ref}
			data-pb-id={boundary.pageBreakId}
			data-pos={boundary.pos}
			className={"page-boundary" + (boundary.id ? " manual" : "")}
			onMouseDown={handleMouseDown}
			style={{
				position: "absolute",
				top: boundary.pos + "pt",
				left: "-" + margins.left + "pt",
				width: size.width + "pt"
			}}
		>
			<div className="drag-handle-wrapper left">
				<div className="draghandle-tooltip">Right click to remove</div>
				<i className="material-icons drag-handle-button faded" onContextMenu={handleContextMenu}>height</i>
			</div>
			<div className="drag-handle-wrapper right">
				<div className="draghandle-tooltip">Right click to remove</div>
				<i className="material-icons drag-handle-button rhs faded" onContextMenu={handleContextMenu}>height</i>
			</div>
		</div>
	);
}

export default PageBoundary;
